import React from "react";

//icons
import Icon from "../../icons/Icon";
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";

//styles
import "../../../../styles/global/information/alert-error.scss";


const AlertError = ({className, alertMessage} : {className?: string, alertMessage : string}) => {
  return (
    <div className={`alert-error-container ${className}`} data-testid="alert-error">
        <div className="alert-error-icon"><Icon iconName={IconLibrary.ALERT_INFO} color={"white"} /></div>
        {alertMessage}
    </div>
  );
};

export default AlertError;
